(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cs-cinematic-hero')) {
  customElements.define('cs-cinematic-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.userPaused = false;
      this.setOffset = () => {
        const top = this.getBoundingClientRect().top + window.scrollY;
        if (top > 0) this.style.setProperty('--cs-hero-top', Math.round(top) + 'px');
      };
      this.setOffset();
      window.addEventListener('resize', this.setOffset, { passive: true });
      const source = this.mobile.matches && this.dataset.mobile ? this.dataset.mobile : this.dataset.desktop;
      if (!source) return;
      this.button.hidden = false;
      const load = () => {
        if (!this.video.src) { this.video.src = source; this.video.muted = true; }
      };
      const play = () => { load(); this.video.play().catch(() => this.update()); };
      this.video.addEventListener('playing', () => { this.video.classList.add('is-ready'); this.update(); });
      this.video.addEventListener('pause', () => this.update());
      // Soften the loop seam: fade to the poster just before the end, fade back in after restart.
      this.video.addEventListener('timeupdate', () => {
        const d = this.video.duration;
        if (!d || this.reduce.matches) return;
        const t = this.video.currentTime;
        if (d - t < 0.55) this.video.classList.add('is-looping');
        else if (t > 0.12) this.video.classList.remove('is-looping');
      });
      this.video.addEventListener('error', () => { this.video.classList.remove('is-ready'); this.button.hidden = true; });
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.video.paused) play(); else this.video.pause();
      });
      this.visibilityHandler = () => {
        if (document.hidden) this.video.pause();
        else if (this.inView && !this.userPaused && !this.reduce.matches && !navigator.connection?.saveData) play();
      };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.reducedHandler = () => { if (this.reduce.matches) { this.video.pause(); this.video.classList.remove('is-ready'); } };
      this.reduce.addEventListener('change', this.reducedHandler);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (!this.inView) this.video.pause();
        else if (!this.userPaused && !this.reduce.matches && !navigator.connection?.saveData) play();
      }, { threshold: 0.05 });
      this.observer.observe(this.querySelector('.cs-hero__media'));
    }
    update() {
      this.button.textContent = this.video.paused ? this.button.dataset.play : this.button.dataset.pause;
      this.button.setAttribute('aria-pressed', String(!this.video.paused));
    }
    disconnectedCallback() {
      this.video?.pause(); this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.reduce?.removeEventListener('change', this.reducedHandler);
      window.removeEventListener('resize', this.setOffset);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
